$(function() {
	$(document).on('click', 'a, button',function() {
		var $v = $(this),
			a = $v.data('ga-action'),
			c = $v.data('ga-category'),
			l = $v.data('ga-label'),
			v = $v.data('ga-value');
		var res = {}, ok = false;
		if (a) { res.eventAction = a; ok = true;}
			if (c) { res.eventCategory = c; ok = true;}
		if (l) { res.eventLabel = l; ok = true;}
		if (v) { res.eventValue = v; ok = true;}
		if (ok) {
			res.hitType = 'event';
			if (typeof ga === 'undefined') {
				console.error('GA not defined', res);
			}else{
				console.log('GA', res);
				ga('send', res);
			}
			if (typeof fbq === 'undefined') {
				console.error('fbq not defined', res);
			}else {
				fbq('track', res.eventAction);
			}

			window.dataLayer = window.dataLayer || [];
			dataLayer.push({ res: null });
			dataLayer.push({event: res.eventAction, res });
		}
	});
});